import { APP_ROUTES } from "~/constants/appRoutes";

type QuizRedirectContext = {
    /** The cart holds a `PRODUCTS_TO_SHOW_CHECKOUT_INSTEAD_PQP` product (face-cream funnel only). */
    hasCheckoutOverrideProduct?: boolean;
    /** The `LIBIDA_PDP` flag is on *and* this is the libida quiz. */
    isLibidaPdp?: boolean;
    hasLibidaInCart?: boolean;
};

/**
 * The single destination rule for the quiz funnel: given the quiz's PQP route and
 * the current flag/cart context, where does the user actually end up?
 *
 * Used by the quiz pages (`componentsDS/Quiz`, `componentsDS/QuizRedesign`) to
 * compute their `finalRedirectURL`, and by `useQuizLink` to resolve a CTA's href up
 * front. Both must agree, otherwise a CTA sends the user somewhere the quiz page
 * would have redirected away from.
 */
export function resolveQuizRedirectURL(pqpRoute: string, { hasCheckoutOverrideProduct = false, isLibidaPdp = false, hasLibidaInCart = false }: QuizRedirectContext = {}): string {
    // The LIBIDA_PDP flag replaces the libida quiz with the PDP, which routes on to
    // the quiz itself when it has not been completed.
    if (isLibidaPdp) {
        return hasLibidaInCart ? APP_ROUTES.CHECKOUT_BILLING : APP_ROUTES.LIBIDA_LP;
    }

    if (hasCheckoutOverrideProduct && pqpRoute === APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM) {
        return APP_ROUTES.CHECKOUT_BILLING;
    }

    if (pqpRoute === APP_ROUTES.PQP_HORMONE_IMBALANCE) {
        return APP_ROUTES.PQP_OESTRA;
    }

    return pqpRoute;
}

